<template>
    <div class="app-container">
        <iframe
		   name="iframeMap"
		   id="iframeMapViewComponent"
		   width="100%"
		   height=""
		   v-bind:src="smgHtmlPath"
		   frameborder="0"
		   scrolling="y"
		   ref="iframeDom"
		  ></iframe>

    </div>
</template>

<script>
export default {
    data() {
        // return {smgHtmlPath: 'http://wanshuiqing.lykangblog.com/dataView/'};
        return {smgHtmlPath: 'http://wanshuiqing.com/dataview/'};
    }
};
</script>

<style scoped>
    iframe{
        height: calc(100vh - 145px);
    }
</style>
